import { api } from 'utility';
import {
  getAutoLoginReportPageDigitalUrl,
  getAutoLoginReportPageDigitalDetailsUrl,
  getAutoLoginReportPageGuildUrl,
  getAutoLoginReportPageDigitalGuildUrl
} from 'URLs';

export const urlTitleAutoLogin = {
  'TRANSACTIONS_WALLET_FORMAT_BANK': getAutoLoginReportPageDigitalUrl(),
  'TRANSACTIONS_WALLET_DETAILS': getAutoLoginReportPageDigitalDetailsUrl(),
  'TRANSACTIONS_GUILD_FORMAT_BANK': getAutoLoginReportPageGuildUrl(),
  'TRANSACTIONS_GUILD_DETAILS': getAutoLoginReportPageDigitalGuildUrl(),

}
/***
 * سرویس به صورت داینامیک عمل میکند . کلید آدرس هارو از سمت پرنت میگیرد و براساس اون از داخل اینام سرویس مورد نظر را انتخاب میکند
 */
export function getAutoLoginService(titleKey, params) {
  return api.get(urlTitleAutoLogin[titleKey], { params }).then((res) => res.data);
}
export default {
  getAutoLoginService
};
